import React from "react";
import Welcome from "../component/sections/Welcome";
import NotFounded from "../component/partials/other/NotFounded";
import InfoCustomerCoworker from "../component/sections/user/InfoCustomerCoworker";
import sitePublisherRoutes from "./site-publisher";
import advertiseRoutes from "./advertise";
import campaignsRoutes from "./campaigns";
import ReportCampaign from "../component/sections/report/ReportCampaign";

const routes = [
  {
    path: "/",
    render: () => <Welcome />,
    exact: true,
  },
  ...sitePublisherRoutes,
  ...advertiseRoutes,
  ...campaignsRoutes,
  {
    path: "/report/campaign",
    render: () => <ReportCampaign />,
    exact: true,
  },
  {
    path: "/user/info-customer-coworker",
    render: () => <InfoCustomerCoworker />,
    exact: true,
  },
  {
    path: "*",
    render: () => <NotFounded />,
    exact: true,
  },
];

export default routes;
